module.exports = __webpack_public_path__ + "static/media/loader.d4933ef4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader.svg
// module id = 1310
// module chunks = 0